<template>
  <div style="background: #f2f2f6; height: 100%">
        <el-row >
          <el-col :span="20">
             <el-radio-group style="margin:10px" fill='#cfa52c' v-model="actiongroup" size="small" @change="groupChange">
      <el-radio-button v-for="item in groupName" :label="item" :key="item"></el-radio-button>
      <el-radio-button  :label="$t('device.noGounp')" ></el-radio-button>
    </el-radio-group>
          </el-col>
          <el-col :span="4">
          <el-select
                size="mini"
                v-model="$store.state.deviceinnerid"
                style="margin:10px"
                v-if="$store.state.devicelist.length>1||$store.state.slavenum"
                 @change="changeDevice"
              >
                <el-option
                  v-for="item in $store.state.devicelist"
                  :key="item.innerid"
                  :label="item.name"
                  :value="item.innerid"
                  v-if="item.subdevs<=($store.state.slavenum+1)||item.type!='heatpump'"
                >
                </el-option>
              </el-select>
              </el-col>
    </el-row>
     <el-descriptions :labelStyle="{width:'200px'}" :contentStyle="{width:'250px'}" :column="3" size="mini" border>
    <el-descriptions-item v-for="d in fixedDp" :key="d.dpid" v-if="!(d.name=='reseterr'&&resetHide)&&!(user.logintype==2&&d.hide)&&getValiddp(d)">
      <template slot="label">
        {{  $i18n.locale=='en'?(d.desc_en||d.desc): d.desc}}
      </template>
          <el-input-number
                v-if="d.type==2"
                size="mini"
                v-model="$store.state.device[d.name]"
                :min="getDpAttr($store.state.device, d.name, 'min')"
                :max="getDpAttr($store.state.device, d.name, 'max')"
                :step="getDpAttr($store.state.device, d.name, 'step')"
                :label=" $i18n.locale=='en'?(d.desc_en||d.desc): d.desc"
                :disabled="!!!$store.state.device.online"
                @change="sendDp($store.state.device, d.name)"
              >
              </el-input-number>
              <el-popover v-else-if="d.name=='msubvld_1'"
  placement="right"
  width="400"
  trigger="click">
  <el-switch v-for="item in dplist.filter(d=>{return d.name.indexOf('msubvld_')==0})" :key="item.dpid"
  v-model="$store.state.device[item.name]"
  active-color="#13ce66"
  inactive-color="#ff4949">
</el-switch>
  <el-button slot="reference">修改</el-button>
</el-popover>
              <el-button v-else-if="d.name=='reseterr'"  :disabled="!!!$store.state.device.online" size="mini" type="primary" @click="sendDp($store.state.device,'reseterr')"> {{ $i18n.locale=='en'?(d.desc_en||d.desc): d.desc}}</el-button>
              <el-button v-else-if="d.type==1&&d.xrw==1&&getSelectItem($store.state.device, d.name).length==1"  :disabled="!!!$store.state.device.online" size="mini" type="primary" @click="sendDp($store.state.device,d.name)"> {{ $i18n.locale=='en'?(d.desc_en||d.desc): d.desc}}</el-button>
              <div v-else-if="d.type==1&&d.xrw==1&&getSelectItem($store.state.device, d.name).length>1">
                 <el-button  :disabled="!!!$store.state.device.online" v-for="item in getSelectItem($store.state.device, d.name)" :key="item.value" size="mini" type="primary" @click="sendDp($store.state.device,d.name,item.value)"> {{ $i18n.locale=='en'?(item.text_en||item.text): item.text}}</el-button>
              </div>
              <el-select
                v-else
                size="mini"
                v-model="$store.state.device[d.name]"
                :disabled="!!!$store.state.device.online"
                @change="sendDp($store.state.device, d.name)"
              >
                <el-option
                  v-for="item in getSelectItem($store.state.device, d.name)"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <span v-if="d.type==2">{{d.unit}}</span>
    </el-descriptions-item>
  </el-descriptions>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
export default {
  name: 'Devices',
  data () {
    return {
      user: {},
      sendDp: null,
      resetHide: true,
      actiongroup: '',
      fixedDp: []
    }
  },
  watch: {
    '$store.state.deviceinnerid': function () {
      this.actiongroup = this.groupName[0] || this.$t('device.noGounp')
      if (this.actiongroup == this.$t('device.noGounp')) {
        this.fixedDp = this.dplist.filter(d => { return !d.groupname })
      } else {
        this.fixedDp = this.dplist.filter(d => { return d.groupname == this.actiongroup })
      }
    }
  },
  computed: {
    groupName () {
      let groupname = this.dplist.filter(d => { return d.groupname }).map(d => { return d.groupname })
      groupname = Array.from(new Set(groupname))
      return groupname
    },
    dplist: {
      get () {
        if (this.$store.state.device && this.$store.state.device.innerid) {
          return this.$store.state.device.dplist.filter(d => { return (d.xrw === 1 || d.xrw === 3) && (!d.subhide || (d.subhide === 1 && this.$store.state.device.subdevs === 1) || (this.$store.state.device.subdevs > 1 && d.subhide > 1)) })
        } else {
          return []
        }
      }
    }
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      this.user = JSON.parse(customer)
      if (this.user.logintype == 2) {
        let dpermission = window.localStorage.getItem('dpermission')
        if (dpermission) {
          dpermission = JSON.parse(dpermission)
          if (dpermission && dpermission.heatpump && dpermission.heatpump.reset) {
            this.resetHide = false
          }
        }
      } else {
        this.resetHide = false
      }

      this.sendDp = _.debounce(function (device, tag, value) {
        let dp = device.dplist.filter(d => { return d.name == tag })
        if (dp && dp.length > 0) {
          let sendv = (tag == 'reseterr' ? (dp[0].options[0].value || 1) : device[tag])
          if (dp[0].xrw == 1 && dp[0].type == 1) {
            if (dp[0].options.length == 1) {
              sendv = dp[0].options[0].value
            } else {
              sendv = value
            }
          }
          let msg = {
            devdpmsg: {
              devid: device.deviceid,
              dpid: dp[0].dpid,
              data: sendv
            }
          }
          this.Common.mqttSend(device.srcaddress, msg)
        }
      }, 300)
      this.actiongroup = this.groupName[0] || this.$t('device.noGounp')
      if (this.actiongroup == this.$t('device.noGounp')) {
        this.fixedDp = this.dplist.filter(d => { return !d.groupname })
      } else {
        this.fixedDp = this.dplist.filter(d => { return d.groupname == this.actiongroup })
      }
      this.$forceUpdate()
    } else {
      this.$message({
        message: this.$t('base.noSession'),
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    sort: function () {
      this.startSort = !this.startSort
      if (!this.startSort) {
        let dpsort = this.dplist.map((d, i) => { return {sort: i, dpid: d.dpid, protocolid: this.$store.state.device.protocolid} })
        console.log(dpsort)
        Vue.axios
          .post('/equipment/dp/sort/udpate',
            {dplist: dpsort}
          )
          .then((res) => {
            if (res.data.errcode == 0) {
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || this.$t('base.systemError'),
                type: 'error'
              })
            }
          })
      }
    },
    changeDevice () {
      // this.$store.state.device = this.heatpump.filter(d => { return d.innerid == this.$store.state.deviceinnerid })[0]
      this.$store.state.device = this.$store.state.devicelist.filter(d => { return d.innerid == this.$store.state.deviceinnerid })[0]
      this.$forceUpdate()
    },
    getSelectItem (device, tag) {
      let dp = device.dplist.filter((d) => { return d.name == tag })
      if (dp && dp.length > 0) {
        return this.$i18n.locale == 'en' ? dp[0].options_en : dp[0].options
      } else {
        return []
      }
    },
    // sendDp (device, tag) {

    // },
    getDpAttr (device, tag, value) {
      let dp = device.dplist.filter(d => { return d.name == tag })
      if (dp && dp.length > 0) {
        return dp[0][value] || 0
      } else {
        return 0
      }
    },
    getDpText (device, tag) {
      let dp = device.dplist.filter(d => { return d.name == tag })
      if (dp && dp.length > 0) {
        if (dp[0].type == 1) {
          let o = dp[0].options.filter(o => { return o.value == device[tag] })
          if (o && o.length > 0) {
            return o[0].text
          } else {
            return device[tag]
          }
        } else {
          return device[tag]
        }
      } else {
        return ''
      }
    },
    reseterr (device) {
      let dp = device.dplist.filter(d => { return d.name == 'reseterr' })
      if (dp && dp.length > 0) {
        let message = {
          devdpmsg: {
            devid: device.deviceid,
            dpid: dp[0].dpid,
            data: 1
          }
        }
        this.Common.mqttSend(device.srcaddress, message)
      } else {
        this.$message({
          message: this.$t('device.noSupportReset'),
          type: 'error'
        })
      }
    },
    getValiddp (dp) {
      if (dp.validdp) {
        let cdp = this.dplist.filter(d => { return d.dpid == dp.validdp })
        if (cdp && cdp.length > 0) {
          if (JSON.parse(dp.validdt).indexOf(this.$store.state.device[cdp[0].name]) >= 0) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return true
      }
    },
    groupChange () {
      if (this.actiongroup == this.$t('device.noGounp')) {
        this.fixedDp = this.dplist.filter(d => { return !d.groupname })
      } else {
        this.fixedDp = this.dplist.filter(d => { return d.groupname == this.actiongroup })
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-main{
  position: relative;
}

.el-card{
width:80%;
margin-left:10%;
margin-top: 15%;
height:80%
}

.allcontrol{
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
  margin-bottom: 5px;
}

.allcontrolimg{
  width:40px;
  height:40px;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.allcontrolimg_small{
  margin-top: 5px;
  width:20px;
  height:20px;
  background-size: 100% 100%;
  margin-bottom: 5px;
}
.el-table__row .el-table_1_column_5   {
  color: crimson;
}
.bb {
  position: relative;
}
.aa {

  position: absolute;
  top: 0px;
  width: 200px;
  text-align: left;
  z-index:9999;
}
.el-table >>> .el-checkbox__input {
  margin-left: 40px;
}
.el-table >>> .cell {
  padding: 0;
}
/* .el-table >>> .el-table__column-filter-trigger {
  margin-right: 30px;
}
.el-table >>> .el-tag.el-tag--success {
  margin-right: 30px;
} */

</style>




// WEBPACK FOOTER //
// src/components/Devices/HeatpumpControl.vue